/**
 * Route module index — Phases 1–5 complete.
 * Login: PortalLoginPage | Rider v1: RiderLegacyPathRedirects → rider subdomain
 */
export { AdminProtectedRoutes } from './adminRoutes';
export { CompanyProtectedRoutes } from './companyRoutes';
export { MerchantPathRoutes, MerchantSubdomainAuthRoutes } from './merchantRoutes';
export { RiderSubdomainAuthRoutes, RiderSubdomainGuestRoutes } from './riderRoutes';
export { RiderLegacyPathRedirects } from './riderLegacyRoutes';
export { UtilityRoutes, NotFoundRoute } from './sharedRoutes';
export {
  ApexPublicRoutes,
  CompanyGuestRoutes,
  CompanyLoginRoutes,
  AdminSubdomainEntry,
  MerchantSubdomainGuestRoutes,
} from './publicRoutes';
export { CustomerRoutes } from './customerRoutes';